export { ReceiptTax as default } from './ReceiptTax';
